<template>
  <section>
    <filter-categories></filter-categories>
    <images-list></images-list>
  </section>
</template>

<script>
  import ImagesList from "./FilterImagesList";
  import FilterCategories from "./FilterCategories";
  import RouteHeader from "../../shared/RouteHeader";

  import { getFilters, getFilteredImages } from "./FilterActions";

  export default {
    components: {
      ImagesList, FilterCategories, RouteHeader
    },
    vuex: {
      getters: {
        header: state => state.header
      },
      actions: { getFilters, getFilteredImages }
    },
    route: {
      data () {
        this.getFilters();
        this.getFilteredImages();
      }
    }
  };
</script>



// WEBPACK FOOTER //
// Filter.vue?24d62011